import isEmpty from 'lodash/isEmpty'

export function goToPath(path) {}

function isObjEmpty(obj) {
  return Object.values(obj).filter(one => !isEmpty(one)).length > 0
}

export function removeDuplicatesFromObjectArr(objectArray) {
  return objectArray
    .filter(isObjEmpty)
    .map(one => JSON.stringify(one))
    .filter((item, index, array) => array.indexOf(item) === index)
    .map(one => JSON.parse(one))
}

export const diffOfTwoObject = (obj1, obj2) => {
  const theSame = []
  Object.keys(obj1).forEach(key => {
    const val1 = JSON.stringify(obj1[key])
    const val2 = JSON.stringify(obj2[key])
    if (val1 === val2) {
      theSame.push(key)
    }
  })
  return Object.keys(obj1)
    .filter(key => !theSame.includes(key))
    .map(key => {
      return {
        key,
        oldValue: obj2[key],
        newValue: obj1[key]
      }
    })
}

export const promisify = callback => {
  return function (args) {
    return new Promise((resolve, reject) => {
      try {
        const res = callback(args)
        resolve(res)
      } catch (err) {
        reject(err)
      }
    })
  }
}
